import { AxiosRequestConfig } from 'axios';
import { httpApi, httpApiAuth, httpApiAuthDomain } from '@app/api/http.api';
// import './mocks/auth.api.mock';
import { UserModel } from '@app/domain/UserModel';

export interface AuthData {
  email: string;
  password: string;
}

export interface SignUpRequest {
  fullName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface SecurityCodePayload {
  code: string;
}

export interface NewPasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  code: number;
  data: {
    access_token: string;
    user: UserModel;
    refresh_token: string;
  };
}

export interface ProfileUpdateRequest {
  username: string;
  fullName: string;
}

export interface LogoutRequest {
  refreshToken: string;
}

export interface AddUserRequest { }

export const login = (loginPayload: LoginRequest): Promise<LoginResponse> =>
  httpApiAuth.post<LoginResponse>('/login', { ...loginPayload }).then((response) => {
    // console.log('---------', response);
    if (response) {
      return response.data;
    }
    return response;
  });

/** Signs out at the backend. `config` lets `doLogout` pin the backend and token captured before it cleared the session. */
export const logout = (logoutPayload: LogoutRequest, config?: AxiosRequestConfig): Promise<{}> =>
  httpApiAuth.post('/logout', { ...logoutPayload }, config).then(
    (response) => {
      // console.log('---------',response);
      if (response) {
        return response.data;
      }
      return response;
    },
    (error) => {
      console.log('oops something went wrong ', error);
    },
  );

export const getProfile = (): Promise<any> =>
  httpApiAuth.get<any>('/me/profile', {}).then(({ data }) => data);

export const signUp = (signUpData: SignUpRequest): Promise<undefined> =>
  httpApi.post<undefined>('signUp', { ...signUpData }).then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> =>
  httpApiAuth.post<undefined>('/forgotPassword', { ...resetPasswordPayload }).then(({ data }) => data);

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi.post<undefined>('verifySecurityCode', { ...securityCodePayload }).then(({ data }) => data);

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApiAuth.patch<undefined>('/me/password', { ...newPasswordData }).then(({ data }) => data);

export const setProfile = (profileReq: ProfileUpdateRequest): Promise<undefined> =>
  httpApiAuth.patch<undefined>('/me/profile', { ...profileReq }).then(({ data }) => data);

export const addUser = (addUserReq: AddUserRequest): Promise<undefined> =>
  httpApiAuthDomain.post<undefined>('/api/auth/v0/users', { ...addUserReq }).then(({ data }) => data);
